import { css } from "styled-components";
import { fontWeight, gutter } from "@app/styles/helpers/theme";
import { fromMedia } from "@app/styles/helpers/mediaQueries";

export const helpers = css`
    .ml-auto,
    .mx-auto {
        margin-left: auto !important;
    }

    .mb-2 {
        margin-bottom: 0.5rem !important;
    }

    .mb-3 {
        margin-bottom: 1rem !important;
    }
    .pl-0 {
        padding-left: 0 !important;
    }

    .mr-2,
    .mx-2 {
        margin-right: 0.5rem !important;
    }

    .list-unstyled {
        padding-left: 0;
        list-style: none;
    }

    .no-results-list {
        li {
            margin-left: ${gutter(4)};
            list-style: disc;
        }
    }

    .text-center {
        text-align: center !important;
    }

    .text-right {
        text-align: right !important;
    }

    .font-weight-bold {
        font-weight: ${fontWeight("bold")} !important;
    }

    .word-break {
        word-break: break-word;
    }

    .nowrap {
        white-space: nowrap;
    }

    .ellipsis {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .text-md-right {
        ${fromMedia.MD`
            text-align: right;
        `}
        ${fromMedia.LG`
            text-align: inherit;
        `}
    }

    .text-lg-right {
        ${fromMedia.LG`
            text-align: right;
        `}
    }
`;
